import { render, staticRenderFns } from "./_Planos.vue?vue&type=template&id=f4318114&scoped=true"
import script from "./_Planos.vue?vue&type=script&lang=ts"
export * from "./_Planos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4318114",
  null
  
)

export default component.exports